// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import upload01Icon from "@/assets/icons/upload-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Upload01IconProps = Omit<IconProps, "name">;

export function Upload01Icon(props: Upload01IconProps): React.ReactNode {
  return <Icon name={upload01Icon} {...props} />;
}
